import { __read, __assign } from './../../external_lib/tslib/tslib.es6.js';
import React__default, { forwardRef, useState, useImperativeHandle } from 'react';
import classNames from './../../external_lib/classnames/index.js';
import HorizonModal from '../../base/HorizonModal/index.js';
import HorizonBanner from '../../base/HorizonBanner/index.js';
import HorizonText, { TextVariant } from '../../base/HorizonText/index.js';
import HorizonButton from '../../base/HorizonButton/index.js';
import styles from '../../components/sublayouts/BannerModalAlert/index.module.scss.js';
var BannerModalAlert = forwardRef(function (_a, ref) {
  var _b = _a.bannerClass,
    bannerClass = _b === void 0 ? '' : _b,
    _c = _a.bannerMessage,
    bannerMessage = _c === void 0 ? null : _c,
    _d = _a.bannerMessageVariant,
    bannerMessageVariant = _d === void 0 ? TextVariant.BODY1 : _d,
    _e = _a.bannerMessageClass,
    bannerMessageClass = _e === void 0 ? '' : _e,
    _f = _a.bannerLink,
    bannerLink = _f === void 0 ? null : _f,
    _g = _a.bannerLinkClass,
    bannerLinkClass = _g === void 0 ? '' : _g,
    bannerLinkCallback = _a.bannerLinkCallback,
    _h = _a.bannerProps,
    bannerProps = _h === void 0 ? {} : _h,
    _j = _a.modalClass,
    modalClass = _j === void 0 ? '' : _j,
    _k = _a.modalCover,
    modalCover = _k === void 0 ? null : _k,
    _l = _a.modalCoverClass,
    modalCoverClass = _l === void 0 ? '' : _l,
    _m = _a.modalBody,
    modalBody = _m === void 0 ? null : _m,
    _o = _a.modalBodyClass,
    modalBodyClass = _o === void 0 ? '' : _o,
    _p = _a.modalAlignment,
    modalAlignment = _p === void 0 ? 'horizontal' : _p,
    _q = _a.modalProps,
    modalProps = _q === void 0 ? {} : _q;
  var _r = __read(useState(false), 2),
    isModalOpen = _r[0],
    setModalOpen = _r[1];
  var onCloseModal = function () {
    setModalOpen(false);
  };
  var onOpenModal = function () {
    setModalOpen(true);
    if (bannerLinkCallback) {
      bannerLinkCallback();
    }
  };
  useImperativeHandle(ref, function () {
    return {
      closeModal: onCloseModal
    };
  }, [onCloseModal]);
  var renderBannerText = function () {
    if (bannerMessage) {
      return React__default.createElement("span", {
        className: "flex items-center"
      }, React__default.createElement(HorizonText, {
        inline: true,
        variant: bannerMessageVariant,
        className: bannerMessageClass
      }, bannerMessage), bannerLink && React__default.createElement(HorizonButton, {
        className: classNames('text-sm text-up-black-80 underline underline-offset-2 hover:!underline-offset-2 px-2', bannerLinkClass),
        type: "link",
        onClick: onOpenModal
      }, bannerLink));
    }
    return null;
  };
  return React__default.createElement(HorizonBanner, __assign({
    className: classNames('items-center !border-l-4 box-border', bannerClass),
    bannerText: renderBannerText()
  }, bannerProps), React__default.createElement(HorizonModal, __assign({
    open: isModalOpen,
    footer: null,
    onCancel: onCloseModal,
    className: classNames(styles.horizonModal, modalClass),
    classNames: {
      mask: styles.modalMask,
      content: styles.modalContent
    },
    centered: true
  }, modalProps), React__default.createElement("div", {
    className: classNames('flex items-center', {
      'flex-col': modalAlignment === 'vertical'
    })
  }, modalCover && React__default.createElement("div", {
    className: classNames(styles.modalCover, 'p-6', modalCoverClass, {
      'w-1/2': !!modalBody && modalAlignment === 'horizontal'
    })
  }, modalCover), React__default.createElement("div", {
    className: classNames(styles.modalBody, 'p-6', modalBodyClass, {
      'w-1/2': !!modalCover && modalAlignment === 'horizontal'
    })
  }, modalBody))));
});
export { BannerModalAlert as default };
//# sourceMappingURL=index.js.map
